import { create } from 'zustand';
import jwtDecode from 'jwt-decode';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import { AUTH_ACCESS_TOKEN, ACCESS_TOKEN } from 'Utils';
import { getAccessToken } from './utils';

type AccessTokenStoreState = {
    accessToken?: string | null;
    fetchAccessToken: () => Promise<void>;
    getUserInfo: () => JWT;
};

export const useAccessTokenStore = create<AccessTokenStoreState>((set, get) => ({
    accessToken: sessionStorage.getItem(ACCESS_TOKEN) ?? sessionStorage.getItem(AUTH_ACCESS_TOKEN),
    fetchAccessToken: async () => {
        const { accessToken, getUserInfo } = get();
        const { authService } = useAuthenticationStore.getState();
        let refresh = false;

        if (!authService) {
            throw new Error('Error with Authentication');
        }

        if (accessToken) {
            refresh = Math.floor(Date.now() / 1000) > getUserInfo().exp;
        }

        const token = await getAccessToken({ authService, refresh });
        set({ accessToken: token });
    },
    getUserInfo: () => {
        const { accessToken } = get();

        if (!accessToken) {
            throw new Error('Invalid Access Token');
        }

        return jwtDecode<JWT>(accessToken);
    }
}));
